import wrapWithProvider from "./src/app-state/wrap-with-provider"
export const wrapRootElement = wrapWithProvider